import moment from 'moment';

const initialGoodsState = {
  goodsNo: null,
  activeTab: '',
  bannerId: '',
  mmsMsg: '',
  mmsTitle: '',
  myTmpltradio: 0,
  senderKey: '',
  profName: '',
  profSeq: null,
  templateCode: '',
  templateContent: '',
  templateId: '',
  templateTitle: '',
  tmpltradio: 0,
  tmpltSeq: null,
  tmpltValCnt: 0,
  valueCnt: 0,
  orderSend: [
  ],
};

const initialState = {
  /**
   * 상품별 주문정보
   * @type {initialGoodsState[]}
   */
  orderGoods: [],
  /** 주문명 */
  orderNm: '',
  /** 발신 번호 */
  callbackNo: '',
  /** 설문 타입(D: 일반형, L: 추첨형) */
  surveyType: '',
  /** 설문 번호 */
  surveyNo: undefined,
  /** 설문명 */
  surveyNm: '',
  /** 응답기간 시작일 */
  surveyResponseStartDate: '',
  /** 응답기간 종료일 */
  surveyResponseEndDate: '',
  /** 설문 이미지 파일 */
  surveyImgFile: '',
  /** 설문 MMS 제목 */
  surveyMmsTitle: '',
  /** 설문 LMS 가격 */
  surveyLmsPrice: 0,
  /** 설문 MMS 이미지 가격 */
  surveyMmsPrice: 0,
  /** 광고성 문자 */
  isAdvertisementMms: true,
  /** 설문 메시지 내용 */
  surveyMsg: '',
  /** 설문 메시지 내용 안의 설문 제목 */
  surveyMsgTitle: '설문에 참여해주세요\n',
  /** 설문 위탁동의(필수) */
  isConsignmentAgree: false,
  /** 설문 전달 방식 (S: 설문 URL문자 발송, C: 설문 URL 생성) */
  surveyDeliveryType: '',
  /** 추첨형 설문 수신자 목록  */
  lotterySurveySend: [],
  /** 예약 발송일 */
  reservedDate: '',
  /** 발신유형 (N: 즉시발송, Y: 일괄예약발송) */
  reservedYn: 'N',
  /** 주문 화면에서 선택되어 노출되는(=편집중인) 상품번호 */
  selectedGoodsNo: undefined,
  /** 수신자 중복 허용 여부 */
  isAllowedDuplicateReceiver: true,
  /** 상품 정보 목록 */
  goodsInfoList: [],
};

export const home = {
  namespaced: true,

  state: { ...initialState },

  mutations: {
    INITIALIZE(state, goodsInfoList) {
      state.orderGoods = goodsInfoList.map((goodsInfo) => ({
        ...initialGoodsState,
        ...goodsInfo,
      }));
      state.orderNm = initialState.orderNm;
      state.callbackNo = initialState.callbackNo;
      state.reservedDate = moment().format('YYYY-MM-DD 08:00:00');
      state.reservedYn = initialState.reservedYn;
      state.selectedGoodsNo = goodsInfoList?.[0]?.goodsNo;
      state.isAllowedDuplicateReceiver = initialState.isAllowedDuplicateReceiver;
      state.surveyType = initialState.surveyType;
      state.surveyNo = initialState.surveyNo;
      state.surveyNm = initialState.surveyNm;
      state.surveyResponseStartDate = initialState.surveyResponseStartDate;
      state.surveyResponseEndDate = initialState.surveyResponseEndDate;
      state.surveyImgFile = initialState.surveyImgFile;
      state.surveyMmsTitle = initialState.surveyMmsTitle;
      state.surveyMmsPrice = initialState.surveyMmsPrice;
      state.surveyLmsPrice = initialState.surveyLmsPrice;
      state.isAdvertisementMms = initialState.isAdvertisementMms;
      state.surveyMsg = initialState.surveyMsg;
      state.surveyMsgTitle = initialState.surveyMsgTitle;
      state.isConsignmentAgree = initialState.isConsignmentAgree;
      state.surveyDeliveryType = initialState.surveyDeliveryType;
      state.lotterySurveySend = initialState.lotterySurveySend;
    },
    SET_ORDER_GOODS(state, payload) {
      state.orderGoods = payload;
    },
    SET_ORDER_NM(state, payload) {
      state.orderNm = payload;
    },
    SET_CALLBACK_NO(state, payload) {
      state.callbackNo = payload;
    },
    SET_SURVEY_TYPE(state, payload) {
      state.surveyType = payload;
    },
    SET_SURVEY_NO(state, payload) {
      state.surveyNo = payload;
    },
    SET_SURVEY_NM(state, payload) {
      state.surveyNm = payload;
    },
    SET_SURVEY_RESPONSE_START_DATE(state, payload) {
      state.surveyResponseStartDate = payload;
    },
    SET_SURVEY_RESPONSE_END_DATE(state, payload) {
      state.surveyResponseEndDate = payload;
    },
    SET_SURVEY_IMG_FILE(state, payload) {
      state.surveyImgFile = payload;
    },
    SET_SURVEY_MMS_TITLE(state, payload) {
      state.surveyMmsTitle = payload;
    },
    SET_SURVEY_LMS_PRICE(state, payload) {
      state.surveyLmsPrice = payload;
    },
    SET_SURVEY_MMS_PRICE(state, payload) {
      state.surveyMmsPrice = payload;
    },
    SET_IS_CONSIGNMENT_AGREE(state, payload) {
      state.isConsignmentAgree = payload;
    },
    SET_IS_ADVERTISEMENT_MMS(state, payload) {
      state.isAdvertisementMms = payload;
    },
    SET_SURVEY_MSG(state, payload) {
      state.surveyMsg = payload;
    },
    SET_SURVEY_MSG_TITLE(state, payload) {
      state.surveyMsgTitle = payload;
    },
    SET_SURVEY_DELIVERY_TYPE(state, payload) {
      state.surveyDeliveryType = payload;
    },
    SET_LOTTERY_SURVEY_SEND(state, payload) {
      state.lotterySurveySend = payload;
    },
    SET_RESERVED_DATE(state, payload) {
      state.reservedDate = payload;
    },
    SET_RESERVED_YN(state, payload) {
      state.reservedYn = payload;
    },
    SET_SELECTED_GOODS_NO(state, payload) {
      state.selectedGoodsNo = payload;
    },
    SET_IS_ALLOWED_DUPLICATE_RECEIVER(state, payload) {
      state.isAllowedDuplicateReceiver = payload;
    },
    SET_GOODS_INFO_LIST(state, payload) {
      state.goodsInfoList = payload;
    },
  },

  actions: {
    initialize({ commit }, goodsNoList = []) {
      commit('INITIALIZE', goodsNoList);
    },
    setOrderGoods({ commit }, payload = []) {
      commit('SET_ORDER_GOODS', payload);
    },
    setOrderNm({ commit }, payload) {
      commit('SET_ORDER_NM', payload);
    },
    setCallbackNo({ commit }, payload) {
      commit('SET_CALLBACK_NO', payload);
    },
    setSurveyType({ commit }, payload) {
      commit('SET_SURVEY_TYPE', payload);
    },
    setSurveyNo({ commit }, payload) {
      commit('SET_SURVEY_NO', payload);
    },
    setSurveyNm({ commit }, payload) {
      commit('SET_SURVEY_NM', payload);
    },
    setSurveyResponseStartDate({ commit }, payload) {
      commit('SET_SURVEY_RESPONSE_START_DATE', payload);
    },
    setSurveyResponseEndDate({ commit }, payload) {
      commit('SET_SURVEY_RESPONSE_END_DATE', payload);
    },
    setSurveyImgFile({ commit }, payload) {
      commit('SET_SURVEY_IMG_FILE', payload);
    },
    setSurveyMmsTitle({ commit }, payload) {
      commit('SET_SURVEY_MMS_TITLE', payload);
    },
    setSurveyLmsPrice({ commit }, payload) {
      commit('SET_SURVEY_LMS_PRICE', payload);
    },
    setSurveyMmsPrice({ commit }, payload) {
      commit('SET_SURVEY_MMS_PRICE', payload);
    },
    setIsConsignmentAgree({ commit }, payload) {
      commit('SET_IS_CONSIGNMENT_AGREE', payload);
    },
    setIsAdvertisementMms({ commit }, payload) {
      commit('SET_IS_ADVERTISEMENT_MMS', payload);
    },
    setSurveyMsg({ commit }, payload) {
      commit('SET_SURVEY_MSG', payload);
    },
    setSurveyMsgTitle({ commit }, payload) {
      commit('SET_SURVEY_MSG_TITLE', payload);
    },
    setSurveyDeliveryType({ commit }, payload) {
      commit('SET_SURVEY_DELIVERY_TYPE', payload);
    },
    setLotterySurveySend({ commit }, payload) {
      commit('SET_LOTTERY_SURVEY_SEND', payload);
    },
    setReservedDate({ commit }, payload) {
      commit('SET_RESERVED_DATE', payload);
    },
    setReservedYn({ commit }, payload) {
      commit('SET_RESERVED_YN', payload);
    },
    setGoods({ commit, state }, { goodsNo, payload }) {
      state.orderGoods.map((item) => {
        if (item.goodsNo === goodsNo)
          return {
            ...payload,
            goodsNo,
          };
        return item;
      });
      commit('SET_ORDER_GOODS', payload);
    },
    setSelectedGoodsNo({ commit }, payload) {
      commit('SET_SELECTED_GOODS_NO', payload);
    },
    setIsAllowedDuplicateReceiver({ commit }, payload) {
      commit('SET_IS_ALLOWED_DUPLICATE_RECEIVER', payload);
    },
    setGoodsInfoList({ commit }, payload) {
      commit('SET_GOODS_INFO_LIST', payload);
    },
  },

  getters: {
    surveyState: (state) => state,
  },
};

export default home;